export default "__VITE_ASSET__oNnZJ8lg__"